/* Special Ava PDP: Complete-the-Setting cart bundles. Used by sections/main-product-ava-redesign.liquid. */
(function () {
  function plan(ctx) {
    var data = ctx.data;
    var mainId = ctx.mainId;
    var resolveUpsellEntryByColor = ctx.resolveUpsellEntryByColor;
    function getSelectedSetting() { return ctx.setting; }
    function getSelectedColor() { return ctx.color; }
    function getSelectedPersonCount() { return ctx.people; }
    function hasSettingOption() { return true; }

    function findVariantById(id) {
      if (!data || !data.variants) return null;
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    function findStandardTwin(variant) {
      if (!variant || !data || !data.variants) return null;
      var keys = ['option1', 'option2', 'option3'];
      for (var i = 0; i < data.variants.length; i++) {
        var candidate = data.variants[i];
        var match = true;
        var hasStandard = false;
        for (var k = 0; k < keys.length; k++) {
          var want = variant[keys[k]];
          var got = candidate[keys[k]];
          if (/^(essential|full|extended)/i.test(String(want || ''))) {
            if (!/^standard/i.test(String(got || ''))) match = false;
            else hasStandard = true;
          } else if (want !== got) {
            match = false;
          }
        }
        if (match && hasStandard) return candidate;
      }
      return null;
    }

    function exactUpsellEntry(upsellKey, color) {
      var map = data && data.upsells && data.upsells[upsellKey] && data.upsells[upsellKey].variantsByColor;
      if (!map || !color) return null;
      if (map[color]) return map[color];
      var colorDown = String(color).toLowerCase();
      var keys = Object.keys(map);
      for (var i = 0; i < keys.length; i++) {
        if (String(keys[i]).toLowerCase() === colorDown) return map[keys[i]];
      }
      return null;
    }

    // Essential / Full / Extended share the Standard SKU. When Standard + N
    // accessories at their normal market price equals the setting price, the
    // cart gets those real products. Otherwise the setting variant stays in
    // cart next to the accessories at full price, and a "… Set saving"
    // automatic discount takes the accessories' cost off the Ava line.
    // assets/ava-bundle-guard.js swaps that line to Standard if the
    // accessories are later reduced, since the saving needs all of them.
    function getSettingBundlePlan(mainId) {
      var plan = { mainId: mainId, mainProps: null, items: [] };
      if (!hasSettingOption()) return plan;
      var settingLabel = String(getSelectedSetting() || '');
      var setting = settingLabel.toLowerCase();
      if (!setting || setting.indexOf('standard') !== -1) return plan;

      var color = getSelectedColor();
      var people = getSelectedPersonCount() || 4;
      var upsellKey = null;
      var paidQty = 1;
      // Accessory qty matrix (2pc steak packs / core sets / complete sets):
      // 4→1x or 2 steaks, 8→2x or 4 steaks, 12→3x or 6 steaks, 16→4x or 8 steaks.
      if (setting.indexOf('extended') !== -1 || setting.indexOf('complete') !== -1) {
        upsellKey = 'complete';
        paidQty = Math.max(1, Math.round(people / 4));
      } else if (setting.indexOf('full') !== -1) {
        upsellKey = 'core';
        paidQty = Math.max(1, Math.round(people / 4));
      } else if (setting.indexOf('essential') !== -1) {
        upsellKey = 'steak';
        paidQty = Math.max(1, Math.ceil(people / 2));
      }
      if (!upsellKey) return plan;

      var bundleProps = {
        _ava_bundle: [setting.split(' ')[0], people, color].join('|'),
        _ava_bundle_label: settingLabel.replace(/\s*set\s*$/i, '') + ' Set for ' + people
      };
      function withRole(role) {
        var props = { _ava_bundle_role: role };
        for (var key in bundleProps) props[key] = bundleProps[key];
        return props;
      }

      var current = findVariantById(mainId);
      var standard = findStandardTwin(current);
      var exact = exactUpsellEntry(upsellKey, color);
      var paidOk =
        current && standard && standard.available !== false &&
        exact && exact.id && exact.available !== false &&
        typeof exact.price === 'number' &&
        standard.price + exact.price * paidQty === current.price;

      if (paidOk) {
        plan.mainId = standard.id;
        plan.mainProps = withRole('main');
        // Cart line is Standard; keep the selected setting variant id so the
        // cart thumbnail can show Extended/Full/Essential artwork instead.
        if (current && current.id) {
          plan.mainProps._ava_image_variant = String(current.id);
        }
        plan.items.push({ id: exact.id, quantity: paidQty, properties: withRole('accessory') });
        return plan;
      }

      var entry = exact || resolveUpsellEntryByColor(upsellKey, 'Matte Gold');
      plan.mainProps = withRole('main');
      if (current && current.id) {
        plan.mainProps._ava_image_variant = String(current.id);
      }
      if (standard) {
        plan.mainProps._ava_bundle_std = String(standard.id);
        plan.mainProps._ava_bundle_need = String(paidQty);
      }
      if (entry && entry.id) {
        plan.items.push({ id: entry.id, quantity: paidQty, properties: withRole('accessory') });
      }
      return plan;
    }

    return getSettingBundlePlan(mainId);
  }

  window.AvaSettingBundle = { plan: plan };
})();
